module.exports = __webpack_public_path__ + "img/539.d455ce7c.gif";